import 'bootstrap';
import 'bootstrap-select';
import 'bootstrap-datepicker';

import 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-rowgroup';
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-fixedcolumns';
import 'datatables.net-fixedcolumns-bs4';
//import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-scroller';
import 'datatables.net-fixedheader';
import 'datatables.net-fixedheader-bs4';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons-bs4';

import 'jstree';

import 'jquery-validation';
import 'jquery-validation-unobtrusive';
//import 'jquery.easing';

import 'reflect-metadata'; //used by class-transformer to facilitate json-to-object serialization

//import { Swiper, Navigation, Pagination, Autoplay } from 'swiper';
//Swiper.use([Navigation, Pagination, Autoplay]);

//import 'select2';
//import 'bootstrap-select';

import 'leaflet';
import 'leaflet-svg-shape-markers/dist/leaflet-svg-shape-markers.min.js';
import 'leaflet.vectorgrid/dist/Leaflet.VectorGrid.bundled.js';
import 'leaflet-extra-markers';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';

//import 'intro.js/minified/intro.min.js';

//import 'tiny-slider/dist/tiny-slider';
import { WOW } from 'wowjs/dist/wow';

//import { cloneDeep } from 'lodash';

// EXPORTS

import { DocumentTreeLoader } from './components/document-tree/document-tree-loader'; export { DocumentTreeLoader };
import { DocumentLibraryLoader, DocumentLibraryLoaderV2, DocumentLibraryLoaderWithSharepoint } from './components/document-library/document-library-loader'; export { DocumentLibraryLoader, DocumentLibraryLoaderV2, DocumentLibraryLoaderWithSharepoint };
import { Carousel } from './components/carousel/carousel'; export { Carousel };
import { EditDocumentTreeLoader } from "./components/document-tree/editable-document-tree/edit-document-tree"; export { EditDocumentTreeLoader };

//import { StudyDetailPage } from './network-structure/studies/components/study-detail/study-detail.page'; export { StudyDetailPage };
//import { NewsPage } from './pages/news/news.page'; export { NewsPage };

// SCRIPTS
import './scripts/font-awesome';
import './scripts/date-functions';
import './scripts/number-functions';
//import './scripts/table-functions';
import './components/scroll-to-top/scroll-to-top';



// STYLES
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.min.css';
import 'et-line/style.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.min.css';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
import 'datatables.net-scroller-bs4/css/scroller.bootstrap4.min.css';
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css';
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css';
import 'highcharts/css/highcharts.scss';
import 'jstree/dist/themes/default/style.min.css';
//import 'select2/dist/css/select2.min.css';
//import '@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css';
//import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
//import 'intro.js/minified/introjs.min.css';
//import 'tiny-slider/dist/tiny-slider.css';
import 'animate.css/source/animate.css';

import 'swiper/swiper-bundle.min.css';


import './styles/_base.scss';
import './styles/variables.scss';
import './styles/shared.scss';

import './styles/elements/nav-bar.scss';
//import './styles/elements/footer.scss';
//import './styles/elements/banner-wrapper.scss';
import './styles/elements/button.scss';
import './styles/elements/headings.scss';
import './styles/elements/footer.scss';
import './styles/elements/data-table.scss';
import './styles/elements/filter-section.scss';
import './styles/elements/document-tree.scss';
import './styles/elements/edit-table.scss';
import './styles/elements/file-upload.scss';
import './styles/elements/filter-section.scss';
import './styles/elements/view-item-modal.scss';
import './styles/elements/edit-item-modal.scss';
import './styles/elements/loaders.scss';
import './styles/elements/tabs.scss';
import './styles/elements/dropdown.scss';
import './styles/elements/form-section.scss';
import './styles/elements/custom-search-box.scss';


import './components/scroll-to-top/scroll-to-top.scss';

import './components/document-tree/document-tree.scss';
import './components/carousel/carousel.scss';
import './components/document-tree/editable-document-tree/edit-document-tree.scss';
import './components/document-library/document-library-expand.scss';
import './components/two-col-layout/two-col-layout.scss';
import './components/line-chart/line-chart.scss';
import './components/bar-chart/bar-chart.scss';

import './components/kpi-row/kpi-row.scss';
//import './pages/news/news.scss';

//import './network-structure/studies/components/study-detail/study-detail.scss';


// AUTH MODULE -- imported here to avoid having a separate auth.* bundle
import '../auth/pages/login/login.scss';
import '../auth/components/user-header/user-header.scss';
//import '../auth/pages/auth.scss';
import '../auth/pages/profile/profile.scss';
//import '../auth/pages/management/management.scss';

